import Modals from '../../../shared/types/enums/modals';
import TEmpty from '../templates/empty';
import { routerSelector } from '../../../shared/store/slices/router.slice';
import { useAppSelector } from '../../../shared/store/hooks';

function Empty() {
  const {
    params: { current: currentParams },
  } = useAppSelector(routerSelector);

  return (
    <TEmpty
      message={currentParams?.message as string}
      modal={currentParams?.modal as Modals}
    />
  );
}

export default Empty;
